module.exports = __webpack_public_path__ + "static/frostbyte3-c335f0bdf6fc66d05f3d8953c74685ac.png";